import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { fetchProfile, logout } from '../store/slices/authSlice';

export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  role: 'ADMIN' | 'STAFF';
  is_active: boolean;
  is_developer: boolean;
}

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated, isLoading, user, error, successMessage, profileRequestSent } = useSelector((state: RootState) => state.auth);
  useEffect(() => {
    // トークンが存在し、かつプロファイル未取得なら取得
    const tokens = localStorage.getItem('tokens');
    if (tokens && !profileRequestSent && !user) {
      dispatch(fetchProfile());
    }
  }, [ dispatch, profileRequestSent, user ]);
  const handleLogout = () => {
    dispatch(logout());
  };
  // 開発者モードかどうかを確認するヘルパー関数
  const isDeveloper = (): boolean => {
    return !!user?.is_developer;
  };
  // 管理者かどうかを確認するヘルパー関数
  const isAdmin = (): boolean => {
    return user?.role === 'ADMIN';
  };
  return {
    isAuthenticated,
    isLoading,
    user,
    error,
    successMessage,
    logout: handleLogout,
    isDeveloper,
    isAdmin,
    profileRequestSent
  };
};
export default useAuth;
